$('.content-wrap').click(function () {
    $('.hamburger').removeClass("is-active");
    $('body').removeClass("show-menu");
    
    if($('#logo').attr('src').indexOf('-white.png') > 0)
        $('#logo').attr('src', $('#logo').attr('src').replace('-white.png', '.png'));
        
    $('.brand-others img').each(function() {
        if($(this).attr('src').indexOf('-white.png') > 0)
            $(this).attr('src', $(this).attr('src').replace('-white.png', '.png'));
    });

    $('#navigation').hide();
    $('#navigation').css('position','absolute');
});

$(".hamburger").click(function() {
    $('.home-slider').slick('refresh');

    if($(this).hasClass("is-active")) {
        $(this).removeClass("is-active");
        $('body').removeClass("show-menu");
        
        if($('#logo').attr('src').indexOf('-white.png') > 0)
            $('#logo').attr('src', $('#logo').attr('src').replace('-white.png', '.png'));
        
        $('.brand-others img').each(function() {
            if($(this).attr('src').indexOf('-white.png') > 0)
                $(this).attr('src', $(this).attr('src').replace('-white.png', '.png'));
        });

        $('#navigation').hide();
    } else {
        $(this).addClass("is-active");
        $('body').addClass("show-menu");
        
        if($('#logo').attr('src').indexOf('-white.png') < 1)
            $('#logo').attr('src', $('#logo').attr('src').replace('.png', '-white.png'));

        $('.brand-others img').each(function() {
            if($(this).attr('src').indexOf('-white.png') < 1)
                $(this).attr('src', $(this).attr('src').replace('.png', '-white.png'));
        });
        
        $('#navigation').show();
    }
});


// WEBPACK FOOTER //
// ./js/global/navigation.js